define.alias("shared/utils/segment/system-labels", "calendar/utils/segment/system-labels");